import { render, staticRenderFns } from "./yearOrder.vue?vue&type=template&id=72068d54&scoped=true"
import script from "./yearOrder.vue?vue&type=script&lang=js"
export * from "./yearOrder.vue?vue&type=script&lang=js"
import style0 from "./yearOrder.vue?vue&type=style&index=0&id=72068d54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72068d54",
  null
  
)

export default component.exports